import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { ParentChildInvestigationsEntity } from '../../../domain/entities/investigation-parent-child.entity';

export interface GetParentChildInvestigationsQuery {
  readonly investigationId: string;
}

export interface GetParentChildInvestigationsResult {
  readonly data: ParentChildInvestigationsEntity;
}

@Injectable({ providedIn: 'root' })
export class GetParentChildInvestigationsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetParentChildInvestigationsQuery): Observable<GetParentChildInvestigationsResult> {
    this._state.setLoadingParentChildInvestigations(true);
    this._state.setErrorParentChildInvestigations(null);

    return this._repository.getParentChildInvestigations(query.investigationId).pipe(
      tap((data) => {
        this._state.setParentChildInvestigations(data);
        this._state.setLoadingParentChildInvestigations(false);
      }),
      map((data) => ({ data })),
      catchError((error) => {
        this._state.setErrorParentChildInvestigations(error.message || 'Failed to load parent/child investigations');
        this._state.setLoadingParentChildInvestigations(false);
        return throwError(() => error);
      }),
    );
  }
}
